import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Dev-only: filter noisy third-party warnings/errors in Cursor automation
if (import.meta.env.DEV && typeof navigator !== 'undefined' && navigator.userAgent.includes('Cursor')) {
  const IGNORE = [
    'ERR_BLOCKED_BY_CONTENT_BLOCKER',
    "Failed to execute 'postMessage' on 'DOMWindow'",
    'moving towards a new experience that allows users to choose to browse without third-party cookies',
  ];
  const shouldIgnore = (args: unknown[]) => {
    try {
      const text = args.map(a => (typeof a === 'string' ? a : JSON.stringify(a))).join(' ');
      return IGNORE.some(token => text.includes(token));
    } catch {
      return false;
    }
  };

  const originalWarn = console.warn.bind(console);
  const originalError = console.error.bind(console);

  console.warn = (...args: any[]) => {
    if (!shouldIgnore(args)) originalWarn(...args);
  };
  console.error = (...args: any[]) => {
    if (!shouldIgnore(args)) originalError(...args);
  };
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Register service worker for caching
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}
